import React, { useEffect, useState } from "react";
import { ReactComponent as DashboardIcon } from "../icons/dashboard.svg";
import IPXWalletCard from "../components/dashboard/IPXWalletCard";
import TotalPadalaCard from "../components/dashboard/TotalPadalaCard";
import TotalIncomeCard from "../components/dashboard/TotalIncomeCard";
import TransactionFeesCard from "../components/dashboard/TransactionFeesCard";
import TotalCashReleaseCard from "../components/dashboard/TotalCashReleaseCard";
import TransferAccountCard from "../components/dashboard/TransferAccountCard";
import DatePicker from "../components/DatePicker";
import { jwtDecode } from "jwt-decode";
import withAuthorization from "../components/withAuthorization";
import ProfitOrdersCard from "../components/dashboard/ProfitOrdersCard";
const HomePage = () => {
  const [role, setRole] = useState("");
  const [dateRange, setDateRange] = useState({ dateFrom: '', dateTo: '' });
  
  useEffect(() => {
    var token = localStorage.getItem("appToken");
    if (token) {
      setRole(jwtDecode(token)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]);
    }
  }, []);

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
        <DashboardIcon style={{ width: "50px", height: "50px", marginRight: "10px" }} />
        <h2>Admin Booth Dashboard</h2>
      </div>
      <p>Welcome to the dashboard!</p>
      
      <DatePicker onDateChange={handleDateChange} />
      {(
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          gap: '20px', 
          paddingTop: '20px' 
        }}>
          <IPXWalletCard dateRange={dateRange} />
          <TotalPadalaCard dateRange={dateRange} />
          <TotalIncomeCard dateRange={dateRange} />
          <TransactionFeesCard dateRange={dateRange} />
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '20px',
            flexWrap: 'wrap',
            width: '100%'
          }}>
            <ProfitOrdersCard dateRange={dateRange} />
            <TotalCashReleaseCard dateRange={dateRange} />
           
          </div>
        </div>
      )}
    </div>
  );
};

export default withAuthorization(HomePage,1);
